module.exports = __webpack_public_path__ + "img/06.b43bac2a.jpg";